import { validateRecommendationsSearch } from '@recommendations/features/recommendations-filters';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { protectedRoute } from './_root';

export const managementRecommendationsRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'management/recommendations',
  component: lazyRouteComponent(() =>
    import('@recommendations/pages/recommendations').then((m) => ({
      default: m.RecommendationsPage,
    }))
  ),
  validateSearch: validateRecommendationsSearch,
});
